module.exports = __webpack_public_path__ + "static/media/Banner_Tia_Ge.d31e92b0.jpg";